module.exports = require("@material-ui/core/DialogTitle");